import { useFavoriteProductsCardsQuery } from '@shared/generated'

export const useFavoriteCount = (shopId: string) => {
  const { data } = useFavoriteProductsCardsQuery({
    variables: {
      shopId,
      pager: { page: 1, limit: 1 },
    },
    fetchPolicy: 'cache-first',
  })

  return data?.favoriteProducts?.pageInfo?.total ?? 0
}